// today in the Philippines, YYYY-MM-DD
const today = () =>
  new Date().toLocaleDateString("en-CA", { timeZone: "Asia/Manila" });

/**
 * Demo of a branch from its settings (same rule as server/utilities/demo.js):
 * a demo with an end date (settings.eod) can be used up to that day, and is
 * closed from the next day until it is promoted.
 * Returns { end, isOver, daysLeft }; end is "" when promoted or without a date.
 */
const demoOf = (settings = {}) => {
  const { subscription = "demo", eod } = settings || {};
  const day = String(eod || "").slice(0, 10);
  const end =
    subscription === "demo" && /^\d{4}-\d{2}-\d{2}$/.test(day) ? day : "";
  if (!end) return { end, isOver: false, daysLeft: null };

  const daysLeft = Math.round((new Date(end) - new Date(today())) / 86400000);
  return { end, isOver: daysLeft < 0, daysLeft };
};

export default demoOf;
